// removed by extract-text-webpack-plugin
module.exports = {"loader":"ButtonLoader__loader___LL7cI","circle1":"ButtonLoader__circle1___1OMRX","circle2":"ButtonLoader__circle2___Kn0uG","circleScale":"ButtonLoader__circleScale___VPXtu"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Loader/ButtonLoader.scss
// module id = 555
// module chunks = 0